import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import { TILE_STATUS } from "constants/status";
import { setInvestmentStepData } from "store/user/investment/actions";
import { selectUserDashboardDetails } from "store/user/account/selectors";
import { selectCurrenKYCStatus, selectKYCServerError } from "store/user/kyc/selectors";

const messages = {
    heading: "your_investment",
    content1: "invest_with_us",
    content2: "meet_two_requirements",
    content3: "adjust_entries_during_investment",
    content4: "contract_document_send",
    content5: "unfortunately_identification_not_success",
    content6: "contact_our_customer_service",
    experienceKnowledgeText: "start_experience_knowledge",
    identificationText: "identification",
    buttonText: "investment_start",
    kycServerError: "kyc_server_error",
};

const statuses = {
    initiated: "fas fa-hourglass-half status-initiated",
    pending: "fas fa-hourglass-half status-pending",
    completed: "fas fa-check-circle status-success",
    hide: "fas fa-check-circle status-success",
    error: "fas fa-times-circle status-error",
};

const processStatus = (status) => statuses[status] || "far fa-circle";

const InvestmentStartScreen = ({
    className,
    setInvestmentStepData,
    userDashboardData = {},
    setIsInitInvestmentSuccess,
    backSlideEffect = "",
    setBackSlideEffect,
    currentKYCStatus,
    isKYCServerError,
}) => {
    useSideModalScrollToTop();

    useEffect(() => {
        setIsInitInvestmentSuccess(false);
    }, []);
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <div className={`${className} investment-process-container investment-start-screen ${backSlideEffect}`}>
                <div className="image-part shadow">
                    <img src={"/images/start.png"} alt="" />
                </div>
                <div className="content-part">
                    <h4 className="text-center">{formatMessage(messages.heading)}</h4>
                    <p>{formatMessage(messages.content1)}</p>
                    <p>{formatMessage(messages.content2)}</p>
                    <div className="investment-needs">
                        <ul>
                            <li>
                                <i className={processStatus(userDashboardData && userDashboardData.StatusAdequacy)} />
                                {formatMessage(messages.experienceKnowledgeText)}
                            </li>
                            <li>
                                <i className={processStatus(currentKYCStatus)} />
                                {formatMessage(messages.identificationText)}
                            </li>
                        </ul>
                    </div>
                    {isKYCServerError ? (
                        <span className="text-16 alert-red-color">{formatMessage(messages.kycServerError)}</span>
                    ) : currentKYCStatus === TILE_STATUS.ERROR ? (
                        <>
                            <p>{formatMessage(messages.content5)}</p>
                            <p>{formatMessage(messages.content6)}</p>
                        </>
                    ) : (
                        <>
                            <p>{formatMessage(messages.content3)}</p>
                            <p>{formatMessage(messages.content4)}</p>
                        </>
                    )}
                </div>
            </div>
            <div className="bottom-bar-container">
                <PrevButton
                    onClick={() => {
                        setInvestmentStepData({ step: "investmentSum" });
                        setBackSlideEffect("step-slide-right");
                    }}
                />
                <NextButton
                    className={`${(isKYCServerError || currentKYCStatus === TILE_STATUS.ERROR) && "disable-grey"}`}
                    title={formatMessage(messages.buttonText)}
                    onClick={() => {
                        if (!isKYCServerError || currentKYCStatus !== TILE_STATUS.ERROR) {
                            setInvestmentStepData({ step: "investmentProcess" });
                            setBackSlideEffect("step-slide-left");
                        }
                    }}
                />
            </div>
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    userDashboardData: selectUserDashboardDetails,
    currentKYCStatus: selectCurrenKYCStatus,
    isKYCServerError: selectKYCServerError,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentStartScreen);
